<template>
    <div @click="previewImages" ref="container">
        <img src="@/assets/images/cec2023/info_1.jpg" v-if="type==1"/>
        <img src="@/assets/images/cec2023/info_2.jpg" v-if="type==1"/>
        <img src="@/assets/images/cec2023/info_3.jpg" v-if="type==1"/>
        <img src="@/assets/images/cec2023/schedule.jpg" v-if="type==2"/>
    </div>
</template>

<script>
export default {
    data(){
        return{
            type:0
        }
    },
    created(){
        console.log(this.$route.path)
        if (this.$route.path=='/cec2023/info') {
            this.type=1
        }
        else if(this.$route.path=='/cec2023/schedule'){
            this.type=2
        }
    },
    methods:{
        previewImages(e){
            if(e.target && e.target['nodeName'] == "IMG"){
                let previewArr = [];
                let imgs = this.$refs.container.querySelectorAll('img');
                imgs.forEach((img)=>{
                    previewArr.push(common.fullUrlProtocol(img.getAttribute('src')));
                })
                console.log(previewArr)
                // common.wxPreviewImage(common.fullUrlProtocol(e.target.getAttribute('src')),previewArr);
            }
        },
    }

}
</script>

<style scoped>
img{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/cec2023/info.vue